if($('.vehicle-listing').length) {

    let makeFilters = $('.make-checkbox'),
        modelFilters = $('.model-checkbox'),
        yearMinInput = $('#year-min'),
        yearMaxInput = $('#year-max'),
        yearMinRangeInput = $('#year-min-range'),
        yearMaxRangeInput = $('#year-max-range'),
        mileageMinInput = $('#mileage-min'),
        mileageMaxInput = $('#mileage-max'),
        mileageMinRangeInput = $('#mileage-min-range'),
        mileageMaxRangeInput = $('#mileage-max-range'),
        priceMinInput = $('#price-min'),
        priceMaxInput = $('#price-max'),
        priceMinRangeInput = $('#price-min-range'),
        priceMaxRangeInput = $('#price-max-range'),
        saleStatusFilters = $('.sale-status-checkbox'),
        softwareFilters = $('.software-checkbox'),
        hardwareFilters = $('.hardware-checkbox'),
        clearButton = $('#clear-search-filters'),
        mobileFiltersToggle = $('#mobile-filters-toggle'),
        sortMenuToggle = $('#vehicle-sort-toggle'),
        sortLabel = $('#vehicle-sort-label'),
        sortMenu = $('#vehicle-sort-menu'),
        sortOptions = $('.sort-options button'),
        sortSelection = 'sale-status',
        page = 1,
        perPage = 29;

    sortMenuToggle.on('click', function() {
        sortMenu.slideToggle();
        sortMenuToggle.toggleClass('active');
    });

    sortOptions.on('click', function() {
        sortOptions.removeClass('active');
        $(this).addClass('active');
        sortSelection = $(this).data('sort');
        sortLabel.text($(this).text());
        sortMenu.slideUp();
        sortMenuToggle.removeClass('active');
        performSearch(true);
    });

    makeFilters.on('change', function() {
        let selectedMakes = makeFilters.filter(':checked').map(function () {
            return $(this).val();
        }).get();

        if(selectedMakes.length > 0) {
            let modelsToShow = new Set();
            selectedMakes.forEach(make => {
                if(window.makeModelMatchup[make]) {
                    window.makeModelMatchup[make].forEach(model => modelsToShow.add(model));
                }
            });

            modelFilters.each(function() {
                if(modelsToShow.has($(this).val())) {
                    $(this).parent().parent().css('display', '');
                } else {
                    $(this).parent().parent().css('display', 'none').prop('checked', false);
                }
            });
        } else {
            modelFilters.parent().parent().css('display', '').prop('checked', false);
        }

        performSearch(true);
    });
    modelFilters.on('change', function() { performSearch(true); });
    yearMinInput.on('input', function() { performSearch(true); });
    yearMaxInput.on('input', function() { performSearch(true); });
    yearMinRangeInput.on('input', function() { performSearch(true); });
    yearMaxRangeInput.on('input', function() { performSearch(true); });
    mileageMinInput.on('input', function() { performSearch(true); });
    mileageMaxInput.on('input', function() { performSearch(true); });
    mileageMinRangeInput.on('input', function() { performSearch(true); });
    mileageMaxRangeInput.on('input', function() { performSearch(true); });
    priceMinInput.on('input', function() { performSearch(true); });
    priceMaxInput.on('input', function() { performSearch(true); });
    priceMinRangeInput.on('input', function() { performSearch(true); });
    priceMaxRangeInput.on('input', function() { performSearch(true); });
    saleStatusFilters.on('change', function() { performSearch(true); });
    softwareFilters.on('change', function() { performSearch(true); });
    hardwareFilters.on('change', function() { performSearch(true); });

    $(document).on('click', '.page-prev', function() {
        if(page > 1) {
            goToPage(page - 1);
        }
    });

    $(document).on('click', '.page-next', function() {
        if(page < $('.page-number').length) {
            goToPage(page + 1);
        }
    });

    $(document).on('click', '.page-number', function() {
        let pageNum = parseInt($(this).data('page'));
        if(pageNum !== page) goToPage(pageNum);
    });

    function goToPage(pageNum) {
        page = pageNum;
        $('.page-number').removeClass('active');
        $('.page-number[data-page="' + page + '"]').addClass('active');
        pageActiveStates();
        performSearch();
    }

    function pageActiveStates() {
        $('.page-prev').prop('disabled', page === 1).prop('aria-disabled', page === 1);
        $('.page-next').prop('disabled', page === $('.page-number').length).prop('aria-disabled', page === $('.page-number').length);
    }

    clearButton.on('click', function() { resetSearch(); });

    mobileFiltersToggle.on('click', function() {
        $('.filters-contents').slideToggle();
        mobileFiltersToggle.toggleClass('active');
    });

    $('.filters-header').on('click', function() {
        if($(window).width() < 992) {
            $('.filters-contents').slideToggle();
            mobileFiltersToggle.toggleClass('active');
        }
    });

    function resetSearch() {
        makeFilters.prop('checked', false);
        modelFilters.prop('checked', false);
        yearMinInput.val('').trigger('input');
        yearMaxInput.val('').trigger('input');
        yearMinRangeInput.val(yearMinRangeInput.attr('min')).trigger('input');
        yearMaxRangeInput.val(yearMaxRangeInput.attr('max')).trigger('input');
        mileageMinInput.val('').trigger('input');
        mileageMaxInput.val('').trigger('input');
        mileageMinRangeInput.val(mileageMinRangeInput.attr('min')).trigger('input');
        mileageMaxRangeInput.val(mileageMaxRangeInput.attr('max')).trigger('input');
        priceMinInput.val('').trigger('input');
        priceMaxInput.val('').trigger('input');
        priceMinRangeInput.val(priceMinRangeInput.attr('min')).trigger('input');
        priceMaxRangeInput.val(priceMaxRangeInput.attr('max')).trigger('input');
        saleStatusFilters.prop('checked', false);
        softwareFilters.prop('checked', false);
        hardwareFilters.prop('checked', false);

        document.querySelectorAll('.range-slider').forEach(slider => {
            slider.style.setProperty('--range-min', '0%');
            slider.style.setProperty('--range-max', '100%');
        });

        performSearch();
    }

    function performSearch(resetPage = false) {

        if(resetPage) {
            page = 1;
        }

        let vehicles = [...window.vehicles];

        switch(sortSelection) {
            case 'model-asc':
                vehicles.sort((a, b) => a.model.localeCompare(b.model));
                break;
            case 'model-desc':
                vehicles.sort((a, b) => b.model.localeCompare(a.model));
                break;
            case 'make-asc':
                vehicles.sort((a, b) => a.make.localeCompare(b.make));
                break;
            case 'make-desc':
                vehicles.sort((a, b) => b.make.localeCompare(a.make));
                break;
            case 'year-asc':
                vehicles.sort((a, b) => a.year - b.year);
                break;
            case 'year-desc':
                vehicles.sort((a, b) => b.year - a.year);
                break;
            case 'price-asc':
                vehicles.sort((a, b) => {
                    let priceA = parseFloat(a.price.replace(/[^0-9.-]+/g, ""));
                    let priceB = parseFloat(b.price.replace(/[^0-9.-]+/g, ""));
                    if(isNaN(priceA)) priceA = Infinity;
                    if(isNaN(priceB)) priceB = Infinity;
                    return priceA - priceB;
                });
                break;
            case 'price-desc':
                vehicles.sort((a, b) => {
                    let priceA = parseFloat(a.price.replace(/[^0-9.-]+/g, ""));
                    let priceB = parseFloat(b.price.replace(/[^0-9.-]+/g, ""));
                    return priceB - priceA;
                });
                break;
            case 'mileage-asc':
                vehicles.sort((a, b) => {
                    let mileageA = parseInt(a.mileage.replace(/[^0-9.-]+/g, ""));
                    let mileageB = parseInt(b.mileage.replace(/[^0-9.-]+/g, ""));
                    if(isNaN(mileageA)) mileageA = Infinity;
                    if(isNaN(mileageB)) mileageB = Infinity;
                    return mileageA - mileageB;
                });
                break;
            case 'mileage-desc':
                vehicles.sort((a, b) => {
                    let mileageA = parseInt(a.mileage.replace(/[^0-9.-]+/g, ""));
                    let mileageB = parseInt(b.mileage.replace(/[^0-9.-]+/g, ""));
                    return mileageB - mileageA;
                });
                break;
            case 'sale-status':
                let availableVehicles = vehicles.filter(v => !v.pending_sale && !v.coming_soon);
                let comingSoonVehicles = vehicles.filter(v => v.coming_soon);
                let pendingSaleVehicles = vehicles.filter(v => v.pending_sale);
                vehicles = [...availableVehicles, ...comingSoonVehicles, ...pendingSaleVehicles];
                break;
        }

        let selectedMakes = makeFilters.filter(':checked').map(function () {
                return $(this).val();
            }).get(),
            selectedModels = modelFilters.filter(':checked').map(function () {
                return $(this).val();
            }).get(),
            yearMin = $('#year-min').val(),
            yearMax = $('#year-max').val(),
            mileageMin = $('#mileage-min').val(),
            mileageMax = $('#mileage-max').val(),
            priceMin = $('#price-min').val(),
            priceMax = $('#price-max').val(),
            saleStatus = saleStatusFilters.filter(':checked').map(function () {
                return $(this).val();
            }).get(),
            selectedSoftware = softwareFilters.filter(':checked').map(function () {
                return $(this).val();
            }).get(),
            selectedHardware = hardwareFilters.filter(':checked').map(function () {
                return $(this).val();
            }).get(),
            isFiltering = selectedMakes.length > 0 || selectedModels.length > 0 || yearMin || yearMax || mileageMin || mileageMax || priceMin || priceMax || saleStatus.length > 0 || selectedSoftware.length > 0 || selectedHardware.length > 0;

        // TODO: Colors
        // TODO: Options

        // Step 1: Filter all vehicles and collect matching ones
        let filteredVehicles = [];

        let order = 1;

        vehicles.forEach((vehicle) => {
            let matches = {
                make: true,
                model: true,
                yearMin: true,
                yearMax: true,
                mileageMin: true,
                mileageMax: true,
                priceMin: true,
                priceMax: true,
                saleStatus: true,
                software: true,
                hardware: true,
            }

            $('#vehicle-card-' + vehicle.id).css('order', order++);

            let price = vehicle.price;
            price = price.replace(/[^0-9.-]+/g, "");
            price = parseFloat(price);

            if (selectedMakes.length && !selectedMakes.includes(vehicle.make)) matches.make = false;
            if (selectedModels.length && !selectedModels.includes(vehicle.model)) matches.model = false;
            if (yearMin) matches.yearMin = vehicle.year >= yearMin;
            if (yearMax) matches.yearMax = vehicle.year <= yearMax;
            if (mileageMin) matches.mileageMin = parseInt(vehicle.mileage) >= mileageMin;
            if (mileageMax) matches.mileageMax = parseInt(vehicle.mileage) <= mileageMax;
            if (priceMin) matches.priceMin = price >= priceMin;
            if (priceMax) matches.priceMax = price <= priceMax;
            if (saleStatus.length) {
                matches.saleStatus = false;
                if(saleStatus.includes('pending-sale') && vehicle.pending_sale) matches.saleStatus = true;
                if(saleStatus.includes('coming-soon') && vehicle.coming_soon) matches.saleStatus = true;
                if(saleStatus.includes('available') && !vehicle.pending_sale && !vehicle.coming_soon) matches.saleStatus = true;
            }
            if (selectedSoftware.length) {
                matches.software = false;
                if(vehicle.software && selectedSoftware.some(software => vehicle.software == software)) {
                    matches.software = true;
                }
            }
            if (selectedHardware.length) {
                matches.hardware = false;
                if(vehicle.hardware && selectedHardware.some(hardware => vehicle.hardware == hardware)) {
                    matches.hardware = true;
                }
            }

            // If all criteria match, add to filtered results
            if (matches.make && matches.model && matches.yearMin && matches.yearMax && matches.mileageMin && matches.mileageMax && matches.priceMin && matches.priceMax && matches.saleStatus && matches.software && matches.hardware) {
                filteredVehicles.push(vehicle);
            }
        });

        // Step 2: Calculate pagination based on filtered results
        let filteredVehiclesCount = filteredVehicles.length;
        let totalPages = Math.ceil(filteredVehiclesCount / perPage);

        // Ensure current page doesn't exceed total pages
        if (page > totalPages && totalPages > 0) {
            page = totalPages;
        }

        // Step 3: Determine which vehicles should be shown on current page
        let startIndex = (page - 1) * perPage;
        let endIndex = startIndex + perPage;
        let vehiclesOnCurrentPage = filteredVehicles.slice(startIndex, endIndex);

        // Create a Set of IDs for quick lookup
        let visibleVehicleIds = new Set(vehiclesOnCurrentPage.map(v => v.id));

        // Step 4: Show/hide all vehicles based on whether they're in the current page
        window.vehicles.forEach((vehicle) => {
            if (visibleVehicleIds.has(vehicle.id)) {
                $('#vehicle-card-' + vehicle.id).show();
            } else {
                $('#vehicle-card-' + vehicle.id).hide();
            }
        });

        // Step 5: Build pagination UI
        let paginationHtml = '';

        if (totalPages > 1) {
            paginationHtml += '<li><a href="#" class="page-prev" aria-label="Previous page" aria-disabled="' + (page === 1) + '" tabindex="' + (page === 1 ? '-1' : '0') + '"><svg xmlns="http://www.w3.org/2000/svg" fill="none" width="5" height="10" aria-hidden="true" focusable="false"><path fill="currentColor" d="M0 5c0-.265.088-.52.244-.707l3.333-4c.326-.39.853-.39 1.179 0 .325.39.325 1.023 0 1.414L2.012 5l2.744 3.293c.325.39.325 1.023 0 1.414-.326.39-.853.39-1.179 0l-3.333-4-.055-.073A1.13 1.13 0 0 1 0 5" opacity=".5"/></svg></a></li>';
            for (let i = 1; i <= totalPages; i++) {
                paginationHtml += '<li><a href="#" data-page="' + i + '" class="page-number' + (i === page ? ' active page-current' : '') + '" aria-label="Page ' + i + '"' + (i === page ? ' aria-current="page"' : '') + '>' + i + '</a></li>';
            }
            paginationHtml += '<li><a href="#" class="page-next" aria-label="Next page" aria-disabled="' + (page === totalPages) + '" tabindex="' + (page === totalPages ? '-1' : '0') + '"><svg xmlns="http://www.w3.org/2000/svg" fill="none" width="5" height="10" aria-hidden="true" focusable="false"><path fill="currentColor" d="M5 5c0-.265-.088-.52-.244-.707l-3.333-4c-.326-.39-.853-.39-1.179 0a1.146 1.146 0 0 0 0 1.414L2.988 5 .244 8.293a1.146 1.146 0 0 0 0 1.414c.326.39.853.39 1.179 0l3.333-4 .055-.073A1.13 1.13 0 0 0 5 5"/></svg></a></li>';
        }

        clearButton.toggleClass('hiding', !isFiltering);

        $('.pagination-list').html(paginationHtml);
        pageActiveStates();

    }

    performSearch();

    document.querySelectorAll('.range-slider').forEach(slider => {
        const [minRange, maxRange] = slider.querySelectorAll('input[type="range"]');
        const minInput = document.getElementById(minRange.dataset.rangeMin);
        const maxInput = document.getElementById(minRange.dataset.rangeMax);

        function updateSliderTrack() {
            const min = parseInt(minRange.min);
            const max = parseInt(minRange.max);
            const minVal = parseInt(minRange.value);
            const maxVal = parseInt(maxRange.value);
            const minPct = ((minVal - min) / (max - min)) * 100;
            const maxPct = ((maxVal - min) / (max - min)) * 100;
            slider.style.setProperty('--range-min', minPct + '%');
            slider.style.setProperty('--range-max', maxPct + '%');
        }

        // Range → Number
        minRange.addEventListener('input', () => {
            if (parseInt(minRange.value) > parseInt(maxRange.value)) {
                minRange.value = maxRange.value;
            }
            minInput.value = minRange.value;
            updateSliderTrack();
        });

        maxRange.addEventListener('input', () => {
            if (parseInt(maxRange.value) < parseInt(minRange.value)) {
                maxRange.value = minRange.value;
            }
            maxInput.value = maxRange.value;
            updateSliderTrack();
        });

        // Number → Range
        minInput.addEventListener('input', () => {
            const val = Math.min(parseInt(minInput.value) || parseInt(minRange.min), parseInt(maxRange.value));
            minRange.value = val;
            updateSliderTrack();
        });

        maxInput.addEventListener('input', () => {
            const val = Math.max(parseInt(maxInput.value) || parseInt(maxRange.max), parseInt(minRange.value));
            maxRange.value = val;
            updateSliderTrack();
        });

        updateSliderTrack();
    });

}

// document.addEventListener('DOMContentLoaded', function() {
//     // Wait for Carfax script to load
//     function initCarfaxBadges() {
//         if (typeof CARFAX !== 'undefined' && CARFAX.replaceLinks) {
//             const containers = document.querySelectorAll('[data-vin]');
//
//             containers.forEach(container => {
//                 const vin = container.getAttribute('data-vin');
//                 const partnerId = container.getAttribute('data-carfax-partner');
//
//                 if (vin && partnerId) {
//                     // Replace with Carfax widget
//                     CARFAX.replaceLinks({
//                         element: container,
//                         vin: vin,
//                         partner: partnerId,
//                         size: 'small', // or 'medium', 'large'
//                         badgeType: 'oneowner' // or 'value', 'history'
//                     });
//                 }
//             });
//         } else {
//             // Retry if script hasn't loaded yet
//             setTimeout(initCarfaxBadges, 100);
//         }
//     }
//
//     initCarfaxBadges();
// });
